class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelectorAll('#predictive-search');
    this.input.addEventListener('click', this.debounce((event) => {
      document.querySelector('body').classList.add('open-mobile-search');
      if(this.input.closest('.mobile-serachbox')) if(this.input.closest('.mobile-serachbox').querySelector('#mobSearch').value == ''){
        this.input.closest('.mobile-serachbox').querySelector('.search_bestseller').style.display = 'none';
        this.input.closest('.mobile-serachbox').querySelector('.search_suggestion').style.display = 'block';
      }else{
        this.input.closest('.mobile-serachbox').querySelector('.search_bestseller').style.display = 'block';
        this.input.closest('.mobile-serachbox').querySelector('.search_suggestion').style.display = 'none';
      }
    }).bind(this));
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product,page&resources[limit]=10&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      // this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.predictiveSearchResults.forEach(function(predictiveResult){
        predictiveResult.innerHTML = resultsMarkup;
      });
      this.open();
      if(document.querySelector('.search_bestseller')){
        if(document.querySelector('.top-result').getAttribute('data-count') == '0'){
          document.querySelector('.search_bestseller').style.display = 'block';
        }else{
          document.querySelector('.search_bestseller').style.display = 'none';
        }
      }
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    if(window.outerWidth > 991) document.querySelector('body').classList.add('open-full-search');
    this.predictiveSearchResults.forEach(function(predictiveResult){
      predictiveResult.classList.add('active-predictive-search');
      if(window.outerWidth > 991){
        console.log('predictiveResult',predictiveResult);
        predictiveResult.closest('.predictive-result-wrap').style.display = 'grid';
      }
      predictiveResult.style.display = 'block';
      if(predictiveResult.closest('.predictive-result-wrap').querySelector('.search_bestseller')) 
        predictiveResult.closest('.predictive-result-wrap').querySelector('.search_bestseller').style.display = 'none';
      if(window.outerWidth > 991) predictiveResult.closest('.snippet-search-bar').querySelector('.search_suggestion').style.display = 'none';
      
    });
    // this.predictiveSearchResults.classList.add('active-predictive-search');
    // this.predictiveSearchResults.style.display = 'block';
    if(window.outerWidth < 992){
      document.querySelectorAll('.search_suggestion').forEach(function(searchSuggestion){
        searchSuggestion.style.display = 'none';
      })
      document.querySelectorAll('.search_bestseller').forEach(function(searchBestseller){
        searchBestseller.style.display = 'block';
      })
    }
  }
  close() {
    // if(window.outerWidth > 991) document.querySelector('body').classList.remove('open-full-search');
    this.predictiveSearchResults.forEach(function(predictiveResult){
      predictiveResult.classList.remove('active-predictive-search');
      predictiveResult.style.display = 'none';
      if(predictiveResult.closest('.predictive-result-wrap').querySelector('.search_bestseller')) 
        predictiveResult.closest('.predictive-result-wrap').querySelector('.search_bestseller').style.display = 'grid';
    });
    // this.predictiveSearchResults.classList.remove('active-predictive-search');
    // this.predictiveSearchResults.style.display = 'none';
    // document.querySelectorAll('.search_suggestion').forEach(function(searchSuggestion){
    //   searchSuggestion.style.display = 'block';
    // })
    // document.querySelectorAll('.search_bestseller').forEach(function(searchBestseller){
    //   searchBestseller.style.display = 'block';
    // })
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    let right = window.innerWidth - document.body.clientWidth;
    if(document.querySelector('body').classList.contains('scroll-up')){
      document.querySelector('body').style.paddingRight = right+'px';
      document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
      document.getElementById('shopify-section-announcement-bar').style.width = 'calc(100% + '+right+'px)';
      document.getElementById('shopify-section-header').style.width = 'calc(100% + '+right+'px)';
      document.getElementById('shopify-section-footer').style.width = 'calc(100% + '+right+'px)';
    }else{
      document.querySelector('body').style.paddingRight = '';
      document.querySelector('main').style.width = '';
      document.getElementById('shopify-section-announcement-bar').style.width = '';
      document.getElementById('shopify-section-header').style.width = '';
      document.getElementById('shopify-section-footer').style.width = '';
    }
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','open-account-popup');
    document.querySelector(".mobile-serachbox #mobSearch").focus();
    
  });
});
let deskSearch = document.querySelector('.searchlist button');
if(deskSearch){
  deskSearch.addEventListener('click',function(e){
    let right = window.innerWidth - document.body.clientWidth;
    if(document.querySelector('body').classList.contains('scroll-up')){
      document.querySelector('body').style.paddingRight = right+'px';
      document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
      document.getElementById('shopify-section-announcement-bar').style.width = 'calc(100% + '+right+'px)';
      document.getElementById('shopify-section-header').style.width = 'calc(100% + '+right+'px)';
      document.getElementById('shopify-section-footer').style.width = 'calc(100% + '+right+'px)';
    }else{
      document.querySelector('body').style.paddingRight = '';
      document.querySelector('main').style.width = '';
      document.getElementById('shopify-section-announcement-bar').style.width = '';
      document.getElementById('shopify-section-header').style.width = '';
      document.getElementById('shopify-section-footer').style.width = '';
    }
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','open-account-popup');
    document.querySelector(".snippet-search-bar #deskSearch").focus();
    if(deskSearch.closest('.header-right').querySelector('#predictive-search').classList.contains('active-predictive-search')){
      document.querySelector('body').classList.add('open-full-search');
    }else{
      console.log('here/');
      if(deskSearch.closest('.header-right').querySelector('predictive-search')) if(deskSearch.closest('.header-right').querySelector('predictive-search #deskSearch').value == ''){
        deskSearch.closest('.header-right').querySelector('.predictive-result-wrap').style.display = 'none';
        deskSearch.closest('.header-right').querySelector('.search_suggestion').style.display = 'block';
      }else{
        deskSearch.closest('.header-right').querySelector('.predictive-result-wrap').style.display = 'grid';
        deskSearch.closest('.header-right').querySelector('.search_suggestion').style.display = 'none';
      }
    }
  });
};
if(document.querySelectorAll('.search-close')){
  document.querySelectorAll('.search-close').forEach(function(searchClose){
    searchClose.addEventListener('click',function(e){
      e.preventDefault();
      let right = window.innerWidth - document.body.clientWidth;
      if(document.querySelector('body').classList.contains('open-search')){
        document.querySelector('body').style.paddingRight = '';
        document.querySelector('main').style.width = '';
        document.getElementById('shopify-section-announcement-bar').style.width = '';
        document.getElementById('shopify-section-header').style.width = '';
        document.getElementById('shopify-section-footer').style.width = '';
      }else{
        document.querySelector('body').style.paddingRight = right+'px';
        document.querySelector('main').style.width = 'calc(100% + '+right+'px)';
        document.getElementById('shopify-section-announcement-bar').style.width = 'calc(100% + '+right+'px)';
        document.getElementById('shopify-section-header').style.width = 'calc(100% + '+right+'px)';
        document.getElementById('shopify-section-footer').style.width = 'calc(100% + '+right+'px)';
      }
      // document.querySelector('.mobile-serachbox #mobSearch').value = ''
      document.querySelector('body').classList.remove('open-search','open-full-search','open-mobile-search');
      document.querySelector('.mobile-serachbox .search_bestseller').style.display = 'none';
      document.querySelector('.mobile-serachbox .search_suggestion').style.display = 'none';

      const mobileInput = document.querySelector('.mobile-serachbox #mobSearch');
      if (window.innerWidth <= 991 && mobileInput) mobileInput.value = '';
    });
  });
};
document.querySelector('.overlay-box').addEventListener('click', function(e) {
  if (window.matchMedia("(max-width: 768px)").matches) {
    if (!document.querySelector('body').classList.contains('open-drawer')) {
      document.querySelector('body').classList.remove('open-menu', 'open-quick-buy');
    }
  } else {
    document.querySelector('body').classList.remove('open-menu', 'open-quick-buy');
  }
});
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        let variant_id;
        sizeList.closest('.grid-size-variants').querySelectorAll('.variant-grid').forEach(function(removeActive){
          removeActive.classList.remove('active');
        });
        sizeList.classList.add('active');
        let nextSibling = sizeList.closest('.grid-variant-outer-wrap').nextElementSibling;
        let prevSibling = sizeList.closest('.grid-variant-outer-wrap').previousElementSibling;
        if(nextSibling || prevSibling){
          if(nextSibling) nextSibling.querySelectorAll('grid-size-variants li').forEach((siblingList) => {
            if(!siblingList.classList.contains('active')){
              return false;
            }
          })
          if(prevSibling) prevSibling.querySelectorAll('grid-size-variants li').forEach((siblingList) => {
            if(!siblingList.classList.contains('active')){
              return false;
            }
          })
          let combineValue = '';
          let count = 0;
          sizeList.closest('.grid-variant-outer').querySelectorAll('.variant-grid.active').forEach((activeValue) => {
            count++;
            if(combineValue == ''){
              combineValue = activeValue.getAttribute('data-title')
            }else{
              combineValue = combineValue + ' / ' + activeValue.getAttribute('data-title')
            }
          })
          sizeList.closest('.grid-imagebox').querySelectorAll('.combine-variant-detail li').forEach((finalList) => {
            let title = finalList.getAttribute('data-title');
            if(title == combineValue){
              variant_id = finalList.dataset.id;
            }
          })
        }else{
          variant_id = sizeList.dataset.id;
        }
        console.log('variant_id',variant_id);
        if(variant_id != undefined){
          let error_grid_outer = sizeList.closest('.snippet-product-grid');
          let error_grid = error_grid_outer.querySelector('.grid-error');
          let formData = {
            'items': [{
              'id': variant_id,
              'quantity': 1
            }]
          };
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
          .then((response) => response.json())
          .then((data) => {
            if(data.status == 422)
            {
              error_grid.innerHTML = data.description;
              setTimeout(function(e){
                error_grid.innerHTML = '';
              },2000);
            }else{
              if(document.location.href.indexOf('/cart') > -1) {
                window.location.href = "/cart";
              }else{
                if(typeof load_cart == 'function'){
                  load_cart();
                  setTimeout(function(e){
                    document.querySelector('body').classList.remove('stickybar');
                    document.querySelector('body').classList.add('open-drawer');
                  },500);
                }else{
                  window.location.href = "/cart";
                }          
              }
              sizeList.closest('.grid-size-variants').querySelectorAll('.variant-grid').forEach(function(removeActive){
                removeActive.classList.remove('active');
              });
              const url = '/cart.js';
              fetch(url)
              .then((resp) => resp.json())
              .then(function(data) {
                var cart_count = data.item_count;
                if(cart_count>0){
                  document.querySelector('.cart-count').innerHTML = cart_count;
                }else{
                  document.querySelector('.cart-count').innerHTML = '';
                }
              })
              .catch(function(error) {
                console.log(error);
              })
            }
            gtag("event", "add_to_cart", {
              currency: Shopify.currency.active,
              value: data.items[0].price,
              items: [
                {
                  item_id: data.items[0].product_id,
                  item_name: data.items[0].product_title,
                  affiliation: "Google Merchandise Store",
                  discount: data.items[0].price - (data.items[0].price * 0.10),
                  index: 0,
                  item_brand: data.items[0].product_type,
                  item_list_id: "related_products",
                  item_list_name: "Related Products",
                  item_variant: data.items[0].variant_title,
                  price: data.items[0].price,
                  quantity: data.items[0].quantity
                }
              ]
            });
          })
          .catch((error) => {
            console.error(error);
          });
        }
        
      });
    });
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    if(document.querySelectorAll(".list-menu > li.active")) document.querySelectorAll(".list-menu > li.active").forEach((menuOpen) => {
      menuOpen.classList.remove("active");
    });
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search','open-nav','open-account-popup');
  }
};
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('quantity-input', QuantityInput);
var counttime = 0;
function cartNotification(cartId){
  fetch(window.Shopify.routes.root +'?section_id=cart-notification')
  .then((response) => response.text())
  .then((responseText) => {
    const cnID = 'cart-notification';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart_popup');
    const source = html.getElementById(cnID);
    if(source && destination) destination.innerHTML = source.innerHTML;
    let lastItem = document.querySelector(".ch_items .cn_" + cartId).innerHTML;
    document.querySelector('body').classList.remove('open-quick-buy');
    document.querySelector(".ch_items").innerHTML = lastItem;
    counttime = 0;
    const myInterval = setInterval(timer, 1000);
    function timer() {
      counttime++;
      if(counttime > 4){
        document.querySelector('.cart_popup').innerHTML = '';
        myStop();
      }
    }
    function myStop(){
      clearInterval(myInterval);
    } 
    document.body.addEventListener('click',function(e){
      var popup = document.querySelector('.cart_popup');
      if (!popup.contains(event.target)) {
        popup.innerHTML = '';
      }
    })
    document.querySelector('.cn_btn a').addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.add('open-drawer');
      document.querySelector('.cart_popup').innerHTML = '';
    })
  });
}
const liveChatButtons = document.querySelectorAll('.open-livechat');
Array.from(liveChatButtons).forEach((button) => {
  button.addEventListener('click',function(e){
    document.querySelectorAll('.trengo-vue-iframe').forEach((frames) => {
      if(!frames.classList.contains('visible')){
        document.querySelector('#trengo-web-widget').classList.remove('visible');
      }
    })
    document.querySelector('#trengo-web-widget').classList.toggle('visible');
    function trengoAvailable(){
      if(window.location.hash.startsWith('#open-')){
        window.Trengo.Api.Widget.open(window.location.hash.split('#open-')[1]);
        
        clearInterval(check_trengo);
      }
    }
    check_trengo = setInterval(trengoAvailable, 100);
  })
})
document.addEventListener("DOMContentLoaded", function(){
  if(typeof Shopify !== 'undefined' && Shopify.shop && !Shopify.designMode){
    if(Shopify.country === 'DE'){
      var currentUrl = window.location.href;
      if(!currentUrl.includes('/de')){
        var newUrl = currentUrl.replace(window.location.origin, window.location.origin + '/de');
        window.location.href = newUrl;
      }
    }
  }
});
window.loadShopifySectionFromProduct = () => {
  document.querySelectorAll('.ajax-pack-product').forEach(function(self){
    self.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      var productHandle = self.dataset.handle;
      if (!productHandle) return;

      // Remove active class from all, then add to clicked one
      document.querySelectorAll('.product-inner .singal-product').forEach(function(inner){
        inner.classList.remove('active');
      });
      self.closest('li.singal-product').classList.add('active');

      var route_url = Shopify.routes.root;

      fetch(`${route_url}products/${productHandle}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newSection = doc.querySelector('.section-product ');
          const container = document.querySelector('.section-product ');

          if (newSection && container) {
            container.innerHTML = newSection.innerHTML;

            // Load external scripts (only once)
            const externalScripts = newSection.querySelectorAll('script[src]');
            externalScripts.forEach(oldScript => {
              const newScript = document.createElement('script');
              Array.from(oldScript.attributes).forEach(attr =>
                newScript.setAttribute(attr.name, attr.value)
              );
              document.body.appendChild(newScript);
            });

            // Re-run global listeners after AJAX update
            setTimeout(() => {
              window.loadShopifySectionFromProduct();
              window.loadShopifySectionfromProduct2();
              if (typeof mediaslider === 'function') mediaslider();
              if (typeof product_slider === 'function') product_slider();
            }, 100); // small delay ensures DOM is ready
          }

          window.history.pushState({}, '', `/products/${productHandle}`);
        });

      console.log('productHandle', productHandle);
    });
  });
};

window.loadShopifySectionfromProduct2 = () => {
  document.querySelectorAll('.grid-meta-color ul li a').forEach(function(self){
    self.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      var productHandle = self.href;
      if (!productHandle) return;

      document.querySelectorAll('.grid-meta-color ul li').forEach(function(inner){
        inner.classList.remove('active');
      });
      self.closest('li').classList.add('active');

      fetch(`${productHandle}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newSection = doc.querySelector('.section-product ');
          const container = document.querySelector('.section-product ');

          if (newSection && container) {
            container.innerHTML = newSection.innerHTML;

            const externalScripts = newSection.querySelectorAll('script[src]');
            externalScripts.forEach(oldScript => {
              const newScript = document.createElement('script');
              Array.from(oldScript.attributes).forEach(attr =>
                newScript.setAttribute(attr.name, attr.value)
              );
              document.body.appendChild(newScript);
            });
            loadShopifySectionFromProduct();

            setTimeout(() => {
              window.loadShopifySectionFromProduct();
              window.loadShopifySectionfromProduct2();
              if (typeof mediaslider === 'function') mediaslider();
              if (typeof product_slider === 'function') product_slider();
            }, 100);
          }

          window.history.pushState({}, '', `${productHandle}`);
        });
    });
  });
};

window.loadShopifySectionFromProduct();
window.loadShopifySectionfromProduct2();

// document.addEventListener("DOMContentLoaded", function () {
//   document.addEventListener("click", function (e) {
//     const btn = e.target.closest(".ajax-pack-product");
//     if (!btn) return;

//     const productHandle = btn.dataset.handle;
//     console.log('productHandle', productHandle);
//     if (!productHandle) return;

//     document.body.classList.add("loading-product");
    
    // fetch(`/products/${productHandle}`)
    //    .then(res => res.text())
    //     .then(html => {
    //       console.log('productHandle', html);
    //         // Step 1: Parse the full HTML page
    //         const parser = new DOMParser();
    //         const doc = parser.parseFromString(html, 'text/html');
        
    //         // Step 2: Get only the product section
    //         const newSection = doc.querySelector('#shopify-section-product-section');
    //         const container = document.querySelector('#shopify-section-product-section');
    //         if (newSection && container) {
    //           container.innerHTML = newSection.innerHTML;
    //         }
    //     });
    // });
// });
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});

window.addEventListener('popstate', function () {
  window.location.reload();
});